export * from "-!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Search.vue?vue&type=template&id=7d87ae32&"


//////////////////
// WEBPACK FOOTER
// ./src/components/side-bar/Search.vue?vue&type=template&id=7d87ae32&
// module id = 902
// module chunks = 0